export const menuItems = [
  // { name: "Home", link: "/dashboard-ca" },
  { name: "Family", link: "/families" },
  { name: "Groups", link: "#" },
  // { name: "Notice", link: "/notices" },
  // { name: "Event", link: "/events" },
  // { name: "Newsletter", link: "/newsletters" },
];

export const menuItemsMember = [
  { name: "Dashboard", link: "/member/dashboard" },
  { name: "Church Family", link: "/member/families" },
  { name: "Family Members", link: "/family/members" },
  // { name: "Payments & Dues", link: "/member/payments" },
  // { name: "Outstanding Payments", link: "/member/outstanding" },
];

export const monthOptions = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "Jul" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const monthOptionsv1 = [
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "Jul" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
];

export const timeZoneOptions = [
  { value: "America/New_York", label: "America/New_York (UTC-5)" },
  { value: "America/Chicago", label: "America/Chicago (UTC-6)" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles (UTC-8)" },
  { value: "Asia/Kolkata", label: "Asia/Kolkata (UTC+5:30)" },
  { value: "Asia/Dubai", label: "Asia/Dubai (UTC+4)" },
  { value: "Asia/Hong_Kong", label: "Asia/Hong_Kong (UTC+8)" },
  { value: "Asia/Shanghai", label: "Asia/Shanghai (UTC+8)" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo (UTC+9)" },
  { value: "Asia/Seoul", label: "Asia/Seoul (UTC+9)" },
  { value: "Asia/Jakarta", label: "Asia/Jakarta (UTC+7)" },
  { value: "Asia/Manila", label: "Asia/Manila (UTC+8)" },
  { value: "Asia/Kuala_Lumpur", label: "Asia/Kuala_Lumpur (UTC+8)" },
  { value: "Asia/Ho_Chi_Minh", label: "Asia/Ho_Chi_Minh (UTC+7)" },
  { value: "Asia/Bangkok", label: "Asia/Bangkok (UTC+7)" },
  { value: "Asia/Dhaka", label: "Asia/Dhaka (UTC+6)" },
  { value: "Asia/Kathmandu", label: "Asia/Kathmandu (UTC+5:45)" },
  { value: "Asia/Riyadh", label: "Asia/Riyadh (UTC+3)" },
  { value: "Asia/Tehran", label: "Asia/Tehran (UTC+3:30)" },
  { value: "Europe/London", label: "Europe/London (UTC+0)" },
  { value: "Europe/Paris", label: "Europe/Paris (UTC+1)" },
  { value: "Europe/Berlin", label: "Europe/Berlin (UTC+1)" },
  { value: "Europe/Moscow", label: "Europe/Moscow (UTC+3)" },
  { value: "Europe/Rome", label: "Europe/Rome (UTC+1)" },
  { value: "Europe/Madrid", label: "Europe/Madrid (UTC+1)" },
  { value: "Australia/Sydney", label: "Australia/Sydney (UTC+10)" },
  { value: "Australia/Melbourne", label: "Australia/Melbourne (UTC+10)" },
  { value: "Pacific/Auckland", label: "Pacific/Auckland (UTC+12)" },
  { value: "Africa/Cairo", label: "Africa/Cairo (UTC+2)" },
  { value: "Africa/Johannesburg", label: "Africa/Johannesburg (UTC+2)" },
  { value: "Africa/Lagos", label: "Africa/Lagos (UTC+1)" },
  { value: "Africa/Nairobi", label: "Africa/Nairobi (UTC+3)" },
  { value: "America/Toronto", label: "America/Toronto (UTC-5)" },
  { value: "America/Vancouver", label: "America/Vancouver (UTC-8)" },
  { value: "America/Mexico_City", label: "America/Mexico_City (UTC-6)" },
  { value: "America/Sao_Paulo", label: "America/Sao_Paulo (UTC-3)" },
  { value: "America/Buenos_Aires", label: "America/Buenos_Aires (UTC-3)" },
  { value: "America/Denver", label: "America/Denver (UTC-7)" },
  { value: "America/Phoenix", label: "America/Phoenix (UTC-7)" },
  { value: "America/Anchorage", label: "America/Anchorage (UTC-9)" },
  { value: "America/Honolulu", label: "America/Honolulu (UTC-10)" },
];
